var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTableRow',[_c('BaseTableCell',{attrs:{"colspan":"8"}},[_c('EmptyState',{attrs:{"img-src":_vm.imgSrc,"message":_vm.message}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }